import React, { Component, PropTypes } from 'react';

import './IconButton.css';
import SvgIcon from '../components/SvgIcon';

class IconButton extends Component {
  render() {
    let style = Object.assign({}, this._getDefaultStyle(), this.props.style);
    let iconStyle = Object.assign({}, this._getDefaultIconStyle(), this.props.iconStyle);

    return (
      <div className="iconButton" style={style} onClick={this.props.onClick}>
        <SvgIcon icon={this.props.icon} style={iconStyle} />
      </div>
    );
  }

  _getDefaultStyle() {
    return {
    }
  }

  _getDefaultIconStyle() {
    return {
    }
  }
}

IconButton.propTypes = {
  style: PropTypes.object,
  iconStyle: PropTypes.object,
  icon: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired
}

IconButton.defaultProps = {
  style: {},
  iconStyle: {}
}

export default IconButton;


/** WEBPACK FOOTER **
 ** ./src/components/IconButton.js
 **/